module.exports = "table{width:100%}mat-form-field{padding:20px}mat-spinner{margin:auto}.export-button{margin:20px 10px 0px 15px}.fa-pencil{margin-right:15px}\n"